<template>
  <div class="login_container">
    <my-header/>

    <div class="login_content">
      <mt-field label="手机号" placeholder="请输入您的手机号" type="tel" v-model="postForm.mobile"></mt-field>
      <mt-field label="验证码" placeholder="请输入验证码" type="number" v-model="postForm.code">
        <mt-button type="default">发送验证码</mt-button>
      </mt-field>

      <mt-button type="primary" size="large" @click.native.prevent="handleLogin">登录</mt-button>
    </div>

<!-- lock -->
  </div>
</template>

<script>
import myHeader from '@/components/myHeader.vue'
import { Toast, Field, Button } from 'mint-ui'
import { validatePhone } from '@/utils/validation'
import { isWeixin } from '@/utils/index'

export default {
  name: 'login',
  props: {},
  data () {
    return {
      postForm: {
        mobile: '',
        code: ''
      },
      redirect: undefined
    }
  },
  components: {
    myHeader,
    'mt-field': Field,
    'mt-button': Button
  },
  watch: {
    $route: {
      handler: function (route) {
        this.redirect = route.query && route.query.redirect
      }
    }
  },
  created () {
    this.redirect = this.$route.query.redirect || undefined
  },
  methods: {
    async handleLogin () {
      // TODO 验证表单
      if (!this.postForm.mobile) {
        Toast({
          message: '请输入您的手机号',
          position: 'bottom',
          duration: 3000
        })
        return false
      }

      // if(!(/^1\d{10}$/.test(this.postForm.mobile))) {
      if (!validatePhone(this.postForm.mobile)) {
        Toast({
          message: '手机号有误，请重填',
          position: 'bottom',
          duration: 3000
        })
        return false
      }

      await this.$store.dispatch('LoginByMobile', this.postForm)
      this.$router.push({ path: this.redirect || '/' })
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
  @import "@/assets/css/mixin.scss";
  .login_container {
    color: #333;
    .text {
      margin-top: rem(20);
      font-size: rem(28);
    }
  }
</style>
